import { render, staticRenderFns } from "./CheckDiscountCoupon.vue?vue&type=template&id=c16d4020&scoped=true&"
import script from "./CheckDiscountCoupon.vue?vue&type=script&lang=js&"
export * from "./CheckDiscountCoupon.vue?vue&type=script&lang=js&"
import style0 from "./CheckDiscountCoupon.vue?vue&type=style&index=0&id=c16d4020&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c16d4020",
  null
  
)

export default component.exports